export const setAccessTokenToLS = (access_token) => {
    localStorage.setItem('access_token', access_token);
};
export const getAccessTokenFromLS = () => {
    return localStorage.getItem('access_token') || '';
};
export const clearLS = () => {
    // CHỈ xoá key app, KHÔNG đụng tới 'oidc.*' (để tránh mất cache metadata)
    ['access_token', 'profile', 'isAdmin', 'userInfo', 'returnUrl'].forEach((k) => localStorage.removeItem(k));
};
export const getProfileFromLS = () => {
    const result = localStorage.getItem('profile');
    return result ? JSON.parse(result) : null;
};
export const setProfileToLS = (profile) => {
    setAccessTokenToLS(profile.access_token);
    localStorage.setItem('profile', JSON.stringify(profile));
};
